import React, { useContext } from 'react';
import {
  DictionaryEvidence,
  Evidence,
  ScheduleContext,
  ScheduleJob,
  scheduleJobsFactory,
} from '@eas/common-web';
import { JobsActionbar } from './jobs-actionbar';
import { useEvidencePermission } from '@utils/permission-hook';
import { Permission } from '@enums';

export function ScheduleJobs() {
  const permissions = useEvidencePermission({
    options: {
      NEW: [],
      EDIT: [],
      REMOVE: [],
      REFRESH: [Permission.Default.ADMINISTRATOR],
      SHARE: [Permission.Default.ADMINISTRATOR],
      CHECK: [],
      SAVE: [],
      CLOSE: [],
    },
  });

  const validationSchema = scheduleJobsFactory.useValidationSchema();
  const { jobUrl: url } = useContext(ScheduleContext);

  const evidence = DictionaryEvidence.useDictionaryEvidence<ScheduleJob>({
    identifier: 'SCHEDULE_JOBS',
    apiProps: {
      url,
    },
    tableProps: {
      columns: scheduleJobsFactory.useColumns(),
      tableName: 'Časové úlohy',
      showReportButton: false,
    },
    detailProps: {
      toolbarProps: {
        title: 'Časová úloha',
        ActionBar: JobsActionbar,
        showBtn: permissions,
      },
      FieldsComponent: scheduleJobsFactory.Fields,
      validationSchema,
    },
  });

  return <Evidence {...evidence} />;
}
